import React from "react";
import { sanitizeHtml } from "utils/sanitizeHtml";
import TabcordionContentOneColumn from "components/page/campaign/tabcordion/TabcordionContentOneColumn";
import TabCordionContentTwoColumn from "components/page/campaign/tabcordion/TabCordionContentTwoColumn";

const TabcordionTabContent = (props) => {
	const { componentTitle, toggleState, tabs } = props;
	return (
		<div className="tabcordion--content desktop">
			{tabs.map((tab) => (
				<div
					key={tab.id}
					className={toggleState === tab.id ? "goal-content--active" : "goal-content"}
				>
					<div
						className="tabcordion--content-description t-body-md-heavy"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(tab.goalHeadline) }}
					></div>
					{tab.type === "One-Column-Image" ? (
						<TabcordionContentOneColumn
							aria={tabs[toggleState].alt}
							src={tabs[toggleState].image}
						/>
					) : (
						<TabCordionContentTwoColumn componentTitle={componentTitle} tab={tab} />
					)}
				</div>
			))}
		</div>
	);
};
export default TabcordionTabContent;
